import { BrowserRouter, HashRouter, useRoutes } from 'react-router-dom'
import { isInTauriShell } from '@renderer/lib/runtime'
import { TauriAndroidBackBridge } from '../components/TauriAndroidBackBridge'
import Login from '../pages/Login'
import Register from '../pages/Register'
import Projects from '../pages/Projects'
import ProtectedRoute from './ProtectedRoute'
import ProjectRoute from './ProjectRoute'
import NotFound from '../pages/NotFound'
import Print from '../pages/Print'
import UploadPage from '@renderer/pages/upload/UploadPage'
import StripGenerator from '@renderer/pages/strip/StripGenerator'
// PostHog disabled
// import { PostHogPageView } from '../components/PostHogPageView'

function Routes(): JSX.Element {
  return useRoutes([
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/register',
      element: <Register />
    },
    {
      path: '/print',
      element: <Print />
    },
    {
      element: <ProtectedRoute />,
      children: [
        {
          path: '/:projectId/*',
          element: <ProjectRoute />
        },
        {
          path: '/upload',
          element: <UploadPage />
        },
        {
          path: '/strip',
          element: <StripGenerator />
        },
        {
          path: '/',
          element: <Projects />
        },
        {
          path: '*',
          element: <NotFound />
        }
      ]
    }
  ]) as React.ReactElement
}

export function AppRoutes(): JSX.Element {
  const isElectron = window.navigator.userAgent.toLowerCase().includes('electron')
  // Tauri WebView also needs hash routing (uses tauri://localhost scheme on Android,
  // and file:// on desktop — both incompatible with BrowserRouter's pushState routing).
  const Router = isElectron || isInTauriShell() ? HashRouter : BrowserRouter

  return (
    <Router>
      <TauriAndroidBackBridge />
      {/* PostHog disabled */}
      {/* <PostHogPageView /> */}
      <Routes />
    </Router>
  )
}
